import "./EmBreve.css";

const EmBreve = ({
  titulo = "Em breve",
  descricao = "Estamos trabalhando nessa funcionalidade para trazer uma experiência ainda melhor para você.",
}) => {
  return (
    <div className="app-container">

      <main className="main-content">

        <div className="embreve-wrapper">
          <div className="embreve-card">
            <div className="embreve-icon">🚧</div>

            <h1 className="embreve-title">{titulo}</h1>

            <p className="embreve-desc">{descricao}</p>

            <div className="embreve-footer">
              <a href="/dashboard" className="embreve-btn">
                Voltar ao Dashboard
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EmBreve;
